module.exports = __webpack_public_path__ + "static/media/erroricon.d58be9ca.png";